








import { Component, Prop, Ref, Vue } from 'vue-property-decorator';

@Component({ })
export default class VVideo extends Vue {
  @Prop({ default: () => [] }) readonly sources!: string[];
  @Prop({ default: () => '100%' }) readonly width!: string;
  @Ref() readonly video!: HTMLVideoElement;

  mounted() {
    // start loading video
    this.video.load();
  }

  get playerStyle() {
    return `width: ${this.width}`;
  }

  play() {
    this.video.focus();
    this.video.play();
  }

  pause() {
    this.video.pause();
  }
}
